import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  //全局共享数据
  state: {
	// //七牛云上传路径
    // upload: 'http://cxx-wx.infoclue.net/mobileLogin/uploadImg',
    // showUpload: 'https://s2.infoclue.net/',

    upload: 'https://cxx-wx.carquery.cn/mobileLogin/uploadImg',
    showUpload: 'https://s1.carquery.cn/',
	openId:'',
	userId:'',
	status:'',
	realName:'',
  },
  
  mutations: {
      // 修改token，并将token存入localStorage
	  
	  changeOpenId(state, user) {
	    localStorage.setItem('openId', user.openId);
	  }
  }
})

export default store